export default __webpack_public_path__ + "static/media/11_Itziar.c61d6f83.webp";